export const LOADED_AUTOCOMPLETE_ITEMS = '[autocomplete] Loaded items';
export const LOADED_AUTOCOMPLETE_TOTALS = '[autocomplete] Loaded totals';

export const LoadedAutocompleteItemsAction = (id, payload) => ({
    type: LOADED_AUTOCOMPLETE_ITEMS,
    id,
    payload
});
export const LoadedAutocompleteTotalsAction = (id, payload) => ({
    type: LOADED_AUTOCOMPLETE_TOTALS,
    id,
    payload
});
